<template>
    <input type="file" name="files[]" :multiple="options.maxNumberOfFiles > 1" :accept="options.accept">
</template>

<script>
  import $ from 'jquery';
  import merge from 'lodash/merge';
  import 'blueimp-file-upload/js/vendor/jquery.ui.widget';
  import 'blueimp-file-upload/js/jquery.iframe-transport';
  import 'blueimp-file-upload/js/jquery.fileupload';
  import 'blueimp-file-upload/js/jquery.fileupload-process';
  import 'blueimp-file-upload/js/jquery.fileupload-validate';

  import AuthManager from '../../../common/auth/Manager';

  const uploaderEvents = [
    'fileuploadadd',
    'fileuploadsubmit',
    'fileuploadsend',
    'fileuploaddone',
    'fileuploadfail',
    'fileuploadalways',
    'fileuploadprogress',
    'fileuploadprogressall',
    'fileuploadstart',
    'fileuploadstop',
    'fileuploadchange',
    'fileuploadpaste',
    'fileuploaddrop',
    'fileuploaddragover',
    'fileuploadchunksend',
    'fileuploadchunkdone',
    'fileuploadchunkfail',
    'fileuploadchunkalways',
    'fileuploadprocessstart',
    'fileuploadprocess',
    'fileuploadprocessdone',
    'fileuploadprocessfail',
    'fileuploadprocessalways',
    'fileuploadprocessstop',
  ];

  const defaultOptions = {
    beforeSend: (xhr) => {
      xhr.setRequestHeader('Authorization', 'Bearer ' + AuthManager.getTokenSync());
    },
    dataType: 'json',
    url: process.env.APP_URL + '/fileupload',
  };

  export default {
    props: {
      'options': {
        type: Object,
        default() {
          return {};
        },
      },
    },
    methods: {
      init() {
        let uploader = $(this.$el).fileupload(merge(defaultOptions, this.options));
        for (let event of uploaderEvents) {
          uploader.bind(event, (e, data) => {
            this.$emit(event, data);
          });
        }
      },
      destroy() {
        $(this.$el).off().fileupload().fileupload('destroy');
      },
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
      this.destroy();
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/fileUpload/components/BaseUploader.vue